<div
  nz-row
  class="mt-5">
  <div
    nz-col
    nzSpan="4"></div>

  <div
    nz-col
    nzSpan="8">
    <app-collapsable-nav-card [item]="navItem"></app-collapsable-nav-card>
  </div>
</div>
